import React, { useState, useEffect } from "react";

import moment from "moment";

import AcUnitIcon from "@mui/icons-material/AcUnit";

import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { firestore } from "../firebase";
import Loader from "./Loader";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Card,
  List,
  ListItem,
  CardContent,
  Grid,
  Box,
  Typography,
  Avatar,
  ListItemText,
  useMediaQuery,
  Divider,
  Link,
  Table,
  TableBody,
  TableRow,
  TableCell,
  CardActions,
} from "@mui/material";
import { Stack } from "react-bootstrap";

const File = ({ caption, displayName, createdAt, images, files }) => {
  // const { nanoseconds, seconds } = createdAt !== null && createdAt;
  // var timestamp = { nanoseconds, seconds };
  // const dateTime = new Date(timestamp?.seconds * 1000);
  // const [files, setFiles] = useState([]);
  // useEffect(() => {
  //   const collectionRef = collection(firestore, "sites");
  //   const q = query(collectionRef, orderBy("createAt", "desc"));
  //   const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
  //     setFiles(
  //       QuerySnapshot.docs.map((doc) => ({
  //         ...doc.data(),
  //         id: doc.id,
  //         createAt: doc.data().createAt?.toDate().getTime(),
  //       }))
  //     );
  //   });
  //   return unsubscribe;
  // }, []);

  const { nanoseconds, seconds } = createdAt !== null && createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);
  const [loading, setLoading] = useState(true);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {loading ? (
        <Card
          sx={{
            marginBottom: {
              xs: "14px",
              sm: "22px",
              md: "22px",
              lg: "22px",
            },
          }}
        >
          <CardContent>
            <Loader />
          </CardContent>
        </Card>
      ) : (
        <Card
          sx={{
            marginBottom: {
              xs: "14px",
              sm: "22px",
              md: "22px",
              lg: "22px",
            },
          }}
        >
          <Table>
            <TableBody>
              <TableRow
                sx={{
                  borderBottom: (theme) =>
                    theme.palette.mode === "dark"
                      ? "1px solid #01172E"
                      : "1px solid rgba(127,136,155,0.2)",
                }}
              >
                <TableCell
                  sx={{
                    pt: {
                      xs: 2,
                      sm: 4,
                      md: 4,
                      lg: 4,
                    },
                    pb: {
                      xs: 2,
                      sm: 4,
                      md: 4,
                      lg: 4,
                    },
                    width: "100%",
                  }}
                  fullWidth
                  align="left"
                  style={{ clear: "both", borderBottom: "none" }}
                >
                  {images?.map((images, files) => (
                    <Link
                      target="_blank"
                      sx={{
                        display: "block",
                        height: "110px",
                        height: {
                          xs: "70px",
                          sm: "110px",
                          md: "110px",
                          lg: "110px",
                        },
                        float: "left",
                        background: (theme) =>
                          theme.palette.mode === "dark"
                            ? "#003A65"
                            : "rgba(127,136,155,.1)",
                        padding: "8px",
                        marginLeft: "12px",
                        borderRadius: "5px 5px 5px 5px",
                      }}
                      href={images}
                    >
                      <img
                        src={
                          images.indexOf("files%2Fpdf") >= 0
                            ? "https://cdn3.iconfinder.com/data/icons/dompicon-flat-file-format/256/file-pdf-format-type-512.png"
                            : images.indexOf("2Fdoc") >= 0
                            ? "https://cdn3.iconfinder.com/data/icons/muksis/128/doc-1024.png"
                            : images
                        }
                        height="100%"
                      />
                    </Link>
                  ))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    width: "100%",
                  }}
                  fullWidth
                  colSpan={6}
                  align="right"
                >
                  <Grid container spacing={6}>
                    <Grid item xs={12} md={6} align="left">
                      <Typography color="textSecondary" variant="body2">
                        {displayName} - {moment(dateTime).calendar()}
                      </Typography>
                    </Grid>
                    <Grid
                      // sx={{
                      //   pt: {
                      //     xs: "10px",
                      //     md: "auto",
                      //   },
                      //   paddingTop: "0px",
                      //   padding: "0 0 0 0",
                      // }}

                      item
                      xs={12}
                      md={6}
                    >
                      <Typography
                        color="inherit"
                        align={isSmallScreen ? "left" : "right"}
                        variant="body2"
                      >
                        {caption}
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Card>
      )}
    </>
  );
};

export default File;
